import React from 'react';

export const CopiedIcon = ({ id, props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-labelledby={'svg' + id}
    {...props}
  >
    <title id={'svg' + id}>Copied Question Link</title>
    <g>
      <path
        d="M18.297 7l.703.682L10.26 17 5 12.793l.601-.777 4.565 3.652z"
        fillRule="evenodd"
      />
    </g>
  </svg>
);
